import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { DropdownModule } from 'primeng/dropdown';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TranslateService,
  TranslateModule,
  TranslateLoader,
} from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import {
  ApiModule as OrderApiModule,
  BASE_PATH as ORDER_PATH,
} from '@soctrip/angular-order-service';
import {
  ApiModule as AngularCatalogApiModule,
  BASE_PATH as ANGULAR_CATALOG_PATH,
} from '@soctrip/angular-catalog-service';
import {
  ApiModule as AngularShopApiModule,
  BASE_PATH as ANGULAR_SHOP_PATH,
} from '@soctrip/angular-shop-service';

import {
  ApiModule as PaymentApiModule,
  BASE_PATH as PAYMENT_PATH,
} from '@soctrip/angular-payment-service';

import {
  ApiModule as StorageApiModule,
  BASE_PATH as STORAGE_PATH,
} from '@soctrip/angular-storage-service';

import {
  ApiModule as AdvertisingApiModule,
  BASE_PATH as ADVERTISING_PATH,
} from '@soctrip/angular-advertising-service';
import {
  ApiModule as FinanceApiModule,
  BASE_PATH as FINANCE_PATH,
} from '@soctrip/angular-ecommerce-finance-service';
import {
  ApiModule as ShipmentApiModule,
  BASE_PATH as SHIPMENT_PATH,
} from '@soctrip/angular-shipment-service';
import {
  ApiModule as WalletApiModule,
  BASE_PATH as WALLET_PATH,
} from '@soctrip/angular-ecommerce-wallet-service'

import { environment } from 'src/environments/environment';
import { Locales } from './core/constants/locales.config';

const enum ServiceName {
  STOCK = 'STOCK',
  CATALOG = 'CATALOG',
  SHOP = 'SHOP',
  STORAGE = 'STORAGE',
  ORDER = 'ORDER',
  PAYMENT = 'PAYMENT',
  SHIPMENT = 'SHIPMENT',
  ADVERTISING = 'ADVERTISING',
  FINANCE = 'ECOMMERCE_FINANCE',
  WALLET = "ECOMMERCE_WALLET"
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    DropdownModule,
    SharedModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AngularCatalogApiModule,
    AngularShopApiModule,
    PaymentApiModule,
    StorageApiModule,
    AdvertisingApiModule,
    FinanceApiModule,
    ShipmentApiModule,
    WalletApiModule,
    OrderApiModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: ORDER_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.ORDER]
      }`,
    },
    {
      provide: FINANCE_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.FINANCE]
      }`,
    },
    {
      provide:SHIPMENT_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.SHIPMENT]
      }`,
    },

    {
      provide:WALLET_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.WALLET]
      }`,
    },

    {
      provide: ADVERTISING_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.ADVERTISING]
      }`,
    },
    {
      provide: ANGULAR_CATALOG_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.CATALOG]
      }`,
    },
    {
      provide: ANGULAR_SHOP_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.SHOP]
      }`,
    },
    {
      provide: PAYMENT_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.PAYMENT]
      }`,
    },
    {
      provide: STORAGE_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.STORAGE]
      }`,
    },
    {
      provide: FINANCE_PATH,
      useValue: `${
        environment.BE_URL + environment.SERVICES?.[ServiceName.FINANCE]
      }`,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private translate: TranslateService) {
    this.initI18n();
  }
  private initI18n() {
    this.translate.addLangs(Locales);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
